import React, { FC } from 'react';
import { Autocomplete, Dialog, DialogContent, DialogTitle, TextField } from '@mui/material';
import { WorkoutData } from '../../../models/training.models';
import { EquipmentOption, useLinkEquipment } from './use-link-equipment.hook';

export interface EquipmentSelectDialogProps {
  open: boolean;
  onClose: () => void;
  workoutData: WorkoutData | null | undefined;
  trainingId: number;
  trainingType: 'athlete' | 'coach' | 'guardian';
  onEquipmentLinked?: () => void;
}

const EquipmentSelectDialog: FC<EquipmentSelectDialogProps> = ({
  open,
  onClose,
  workoutData,
  trainingId,
  trainingType,
  onEquipmentLinked,
}) => {
  const { options, autocompleteValue, loadingOptions, linking, handleEquipmentChange } = useLinkEquipment({
    workoutData,
    trainingId,
    trainingType,
    onEquipmentLinked,
  });

  const handleChange = async (event: React.SyntheticEvent, newValue: EquipmentOption | null) => {
    const linked = await handleEquipmentChange(event, newValue);
    if (linked) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: 720,
          maxWidth: '95vw',
        },
      }}
    >
      <DialogTitle>Select Equipment</DialogTitle>
      <DialogContent sx={{ pt: 2.5, pb: 3, px: 3 }}>
        <Autocomplete<EquipmentOption>
          openOnFocus
          disabled={linking}
          loading={loadingOptions || linking}
          options={options}
          getOptionLabel={(o) => o.name}
          isOptionEqualToValue={(a, b) => a.id === b.id}
          value={autocompleteValue}
          onChange={handleChange}
          sx={{ mt: 1 }}
          renderInput={(params) => (
            <TextField
              {...params}
              autoFocus
              label="Equipment"
              variant="outlined"
              placeholder="Search your equipment..."
            />
          )}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EquipmentSelectDialog;
